<template>
  <div>
    <TransitionFade :delay="{ enter: 500, leave: 500 }" :duration="{ enter: 700, leave: 200 }">
      <div
        v-if="appIsReady && locationIsNotDefined"
        class="quaternary rounded-2xl border border-primary bg-primary px-5 py-4"
        v-bind="$attrs"
      >
        <UiTitle severity="h5" class="mb-3">
          Ваш город<br />{{ currentLocation && getLocationName(currentLocation) }}?
        </UiTitle>
        <div class="flex gap-3">
          <UiButton size="small" severity="quaternary" class="px-6 py-2" @click="defineLocation">
            Нет
          </UiButton>
          <UiButton size="small" severity="secondary" class="px-6 py-2" @click="applyCity">
            Да
          </UiButton>
        </div>
      </div>
    </TransitionFade>
    <UiDialog v-model="showChooseLocation" class="bg-primary !p-0">
      <template #default="{ height }">
        <ChooseLocation :style="{ height }" @close="showChooseLocation = false" />
      </template>
    </UiDialog>
  </div>
</template>

<script setup lang="ts">
import { TransitionFade } from '@morev/vue-transitions'
import { storeToRefs } from 'pinia'
import { ref } from 'vue'
import { useConfiguration } from '@/5_entities/Configuration'
import { getLocationName, useLocation } from '@/5_entities/Location'
import { useUser } from '@/5_entities/User'
import { UiButton, UiTitle, UiDialog } from '@/6_shared/ui'
import ChooseLocation from './ChooseLocation.vue'

const props = defineProps<{
  static?: boolean
}>()
const emit = defineEmits<{
  (e: 'reject'): void
}>()
const { appIsReady } = storeToRefs(useConfiguration())
const { locationIsNotDefined, currentLocation } = storeToRefs(useLocation())
const { setLocation } = useLocation()
const { updateUserLocation } = useUser()

defineOptions({
  inheritAttrs: false
})

const showChooseLocation = ref(false)

const defineLocation = () => {
  if (props.static) return emit('reject')

  showChooseLocation.value = true
}

const applyCity = () => {
  updateUserLocation(currentLocation.value!).then(() => setLocation(currentLocation.value!))
  locationIsNotDefined.value = false
}
</script>
